import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from "rxjs/Subject";
import { takeUntil, filter, map } from "rxjs/operators";

@Component({
  selector: 'gen-release-warning',
  templateUrl: './release-warning.component.html',
  styleUrls: ['./release-warning.component.scss']
})
export class ReleaseWarningComponent implements OnInit, OnDestroy {
  private tunnel$: Subject<any>;
  private destroyed$: Subject<any> = new Subject();

  public message: string;
  public callback: (summaryText: string) => void;

  ngOnInit() {
    this.tunnel$
      .asObservable()
      .pipe(
        filter(message => message.emitter != 'children' && message.value),
        map(message => message.value),
        takeUntil(this.destroyed$.asObservable())
      )
      .subscribe(() => {
        this.callback(''); // Call the callback function without passing any argument
        this.tunnel$.next({ emitter: 'children', value: 1 });
      });
  }


  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
